export const graphcoolId =
  process.env.NODE_ENV === "production" ? "stream" : "stream"

export const user = "carine-weve"
